// extracted by mini-css-extract-plugin
module.exports = {"container":"SpinnerWithLabel_container__yRVAw"};